import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import Input from "@/components/Usados/InputField";
import Label from "@/components/Usados/Label";
import Button from "@/components/ui/button/Button";
import Alert from "@/components/ui/alert/Alert";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import FileInput from "@/components/Usados/FileInput";
import { useAuth } from "@/context/AuthContext";
import { apiFetch } from "@/service/api";

export default function CreateConfiguracion() {
  const navigate = useNavigate();
  const initialFormState = {
    moneda: "COP",
    idioma: "Español",
    zona_horaria: "America/Bogota",
    logo: "",
  };

  const [form, setForm] = useState<any>(initialFormState);
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const backend_api = import.meta.env.VITE_API_URL_BACKEND;

  function handleChange(e: any) {
    const { name, value } = e.target;
    setForm((prev: any) => ({ ...prev, [name]: value }));
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    setIsUploading(true);
    setUploadSuccess(false);
    setError(null);
    try {
      const response = await apiFetch(`files/upload`, {
        method: "POST",
        body: formData,
      });
      if (response.ok) {
        const data = await response.json();
        setForm((prev: any) => ({ ...prev, logo: data.filePath }));
        setUploadSuccess(true);
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Error al subir el archivo");
      }
    } catch (err) {
      setError("Error de conexion al subir el archivo");
    } finally {
      setIsUploading(false);
    }
  };

  const getLogoUrl = (logoPath: string) => {
    if (!logoPath) return null;
    if (logoPath.startsWith("http")) return logoPath;
    const filename = logoPath.split("/").pop();
    return `${backend_api}/files/image/${filename}`;
  };

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const response = await apiFetch(`configuracion-empresa/create`, {
        method: "POST",
        body: JSON.stringify(form),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al crear la configuracion");
      }
      setSuccess(true);
      setForm(initialFormState);
      setTimeout(() => {
        navigate("/multiempresa/configuracion_empresas");
      }, 1000);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <PageBreadcrumb pageTitle="Crear Configuracion" />
      <div className="min-h-screen rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <h3 className="mb-8 font-semibold text-gray-800 text-center text-theme-xl dark:text-white/90 sm:text-2xl">
          Crear Nueva Configuracion de Empresa
        </h3>

        {error && (
          <div className="mb-6">
            <Alert variant="error" title="Error" message={error} />
          </div>
        )}
        {success && (
          <div className="mb-6">
            <Alert
              variant="success"
              title="exito"
              message="Configuracion creada correctamente. Redirigiendo..."
            />
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-2">
            <div>
              <Label>Moneda</Label>
              <Input
                name="moneda"
                type="text"
                placeholder="Ej: COP, USD"
                value={form.moneda}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Idioma</Label>
              <Input
                name="idioma"
                type="text"
                placeholder="Ej: es, en"
                value={form.idioma}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label>Zona Horaria</Label>
              <Input
                name="zona_horaria"
                type="text"
                placeholder="Ej: America/Bogota"
                value={form.zona_horaria}
                onChange={handleChange}
                required
              />
            </div>
            <div className={`${user?.rol === 1 ? "lg:col-span-2" : ""}`}>
              <Label>Logo</Label>
              <div className="flex items-center gap-4">
                {form.logo && (
                  <div className="h-16 w-16 overflow-hidden rounded-lg border border-gray-200 dark:border-gray-800">
                    <img
                      src={getLogoUrl(form.logo) || ""}
                      alt="Preview"
                      className="h-full w-full object-contain"
                    />
                  </div>
                )}
                <div className="flex-1">
                  <FileInput className="logo" onChange={handleFileChange} />
                </div>
              </div>
              {isUploading && (
                <p className="mt-2 text-sm text-blue-500 flex items-center gap-2">
                  <span className="animate-spin h-4 w-4 border-2 border-blue-500 border-t-transparent rounded-full"></span>
                  Subiendo archivo...
                </p>
              )}
              {uploadSuccess && (
                <p className="mt-2 text-sm text-green-500">
                  ✓ Archivo cargado correctamente
                </p>
              )}
            </div>
          </div>

          <div className="mt-10 flex justify-end gap-3">
            <Button
              variant="outline"
              size="md"
              type="button"
              onClick={() => navigate("/multiempresa/configuracion_empresas")}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button variant="primary" size="md" type="submit" disabled={loading}>
              {loading ? "Guardando..." : "Crear Configuracion"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}